import { emulatorScreen, mobileScreen } from "../utils/styleUtils";

const BubbleLine1Styles = (theme) => ({
  mainContainer: {
    display: 'flex',
    padding: "2% 1%",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      padding: "1% 1%",
    },
  },

  leftContainer: {
    width: "35%",
    paddingLeft: "15%",
    paddingRight: "5%",

    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      paddingLeft: "8%",
    },
  },
  leftInnerContainer: {
    display: "flex",
    flexDirection: "column",
    width: "90%",
    alignItems: "flex-start",
    paddingTop: 25,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      paddingTop: 0,
    },
  },
  questionText: {
    color: "#003e4c",
    fontSize: 24,
    textAlign: 'left',
    width: "100%",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 12,
      margin: 0
    },
  },
  table: {
    width: "100%",
    marginTop: 20,
    border: "1px solid white",
    borderCollapse: "collapse",
    backgroundColor: "#eeeeee",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      marginTop: 5,
    },
  },

  tableHeader: {
    backgroundColor: "#003e4c",
    color: "#fff",
    height: 50,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 25,
      fontSize: 11
    },
  },
  tableBody: {
    height: 45 ,
    color: "#003e4c",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 25,
      fontSize: 14,
    },
  },

  answerTextContainer: {
    marginTop: 20,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      marginTop: 10
    },
  },
  answerText: {
    textAlign: 'left',
    padding: "12px 0px",
    marginTop: 20 ,
    color: "#003e4c",
    fontSize: 16,
    fontFamily: "Rubik",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      marginTop: 0,
      fontSize: 12,
      padding: "6px 0px",
    },
  },
  correctAnswerContainer: {
    marginTop: 10,
    width: '93%',
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      marginTop: 5,
    },
  },
  incorrectAnswerContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: 20,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      marginTop: 10,
    },
  },
  icon:{
    height: 50,
    float: 'left',
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 20,
    },
  },

  rightContainer: {
    width: "30%",
    position: 'relative',
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      width: "39%",
      marginLeft: "2%"
    },
  },

  graphTitle: {
    color: "#003e4c",
    fontSize: 28,
    fontWeight: "bold",
    paddingLeft: 3,
    fontFamily: "Rubik",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 16,
      margin: 0,
      marginBottom: 5,
      // padding: 0
    },
  },
  buttonContainer: {
    marginLeft: '-35%',
    marginTop: 90,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      marginTop: 25,
      marginLeft: '-25%',
    },
  },
  submitButtom: {
    padding: "10px 20px",
    color: "#fff",
    fontSize: 24,
    fontWeight: 600,
    backgroundColor: "#00b1d9",
    border: "none",
    float: "left",
    cursor: "pointer",
    fontFamily: "Oswald",
    textTransform: "uppercase",
    marginLeft: "10%",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 14,
      padding: "5px 15px",
      marginLeft: "2%"
    },
  },

  submitButtomNext: {
    padding: "10px 50px",
    color: "#fff",
    fontSize: 24,
    fontWeight: 600,
    backgroundColor: "#00b1d9",
    border: "none",
    float: "left",
    cursor: "pointer",
    fontFamily: "Oswald",
    textTransform: "uppercase",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 14,
      padding: "5px 10px",
    },
  },

  // screen 2 spacfic 
  supplyIcon: {
    height: 70, width: 70, position: "absolute", zIndex: 10, right: "-12%", top: 120,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 12,
      // width: 55,
      // // right: "0%",
      // left: 300,
      // top: "25%",
      // height: 25,
      width: 45,
      top: "25%",
      // right: "-14%",
      left: 310,
    },
  },
  socialCostIcon:{
    height: 70, width: 70, position: "absolute", zIndex: 10, right: "-13%", top: "62%",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 25,
      width: 45,
      top: "60%",
      // right: "-14%",
      left: 315,
    },
  },
  demandIcon:{
    height: 80, width: 80, position: "absolute", zIndex: 10, right: "12%", top: "62%",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 25,
      width: 55,
      top: "60%",
      left: 225,
      // right: "-14%",
    },
  },
  externalCostIcon:{
    // width: 100,
    // position: "absolute",
    // zIndex: 10,
    // left: "53%",
    // top: 240,
    width: 158, height: 165, position: "absolute", zIndex: 10, right: "35%", top: 250,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      top: 54,
      left: 130,
      width: 75,
    },
  },


  // screen 3 spacfic
  mainContainer3: {
    display: 'flex',
    padding: "2% 1% 0.3% 1%"
  },
  leftContainer3: {
    width: "40%",
    paddingLeft: "10%",
    paddingRight: "5%",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      width: "43%",
      paddingLeft: "2%",
    },
  },
  innerContainer3: {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column"
  },
  parentDiv3: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "flex-start" 
  },
  titleText3: {
    color: "#003e4c",
    fontSize: 22,
    textAlign: 'left',
    width: "100%",
    marginBottom: 0,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 12,
      marginTop: 0,
    },
  },
  optionContainer3: {
    display: "flex",
    flexDirection: "column",
    width: "95%",
    alignItems: "start",
    paddingLeft: "2%" 
  },
  optionGrid3: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "start",
    paddingLeft: "1%" 
  },
  firstOption3: {
    padding: 0,
    textAlign: "left",
    color: "#043e4b",
    fontSize: 16,
    fontWeight: 500,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 10,
      margin: 5,
    },
  },
  incrementButton3: {
    fontSize:28,
    borderRadius: "50%",
    height: 35,
    width: 35,
    border: 0,
    backgroundColor: "#fff",
    cursor: "pointer",
    color: "#043e4b",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      borderRadius: "50%",
      border: 0,
      padding: 0,
      fontSize:12,
      height: 20,
      width: 20,
    },
  },
  valueText3: {
    padding: "0px 20px",
    fontSize: 28,
    fontWeight: 600,
    width: 90,
    margin: 0,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      width: 60,
      fontSize: 18,
    },
  },
  yesNoOption3: {
    fontSize: 24,
    padding: "10px 20px",
    borderRadius: "10%",
    border: 0,
    color: "#fff",
    cursor: "pointer",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 12,
      padding: "5px 10px",
    },
  },

  socialCostIcon3: {
    height: 70, width: 70, position: "absolute", zIndex: 10, right: "-13%", top: 390,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 25,
      width: 45,
      top: "66%",
      // right: "-14%",
      left: 315,
    },
  },
  supplyIcon3: {
    height: 70, width: 70, position: "absolute", zIndex: 10, right: "-12%", top: 120,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 12,
      width: 45,
      top: "20%",
      left: 315,
    },
  },
  demandIcon3: {
    height: 80, width: 80, position: "absolute", zIndex: 10, right: "12%", top: 390,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 25,
      width: 55,
      top: "66%",
      left: 225,
    },
  },
  correctAnswerContainer3: {
    justifyContent: 'center',
    alignItems: 'end',
    padding: "0% 10%",
    marginTop: 30,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      marginTop: 0,
      padding: "0% 3%",
      alignItems: 'center',
    },
  },
  answerText3: {
    textAlign: 'left', marginTop: '2%', color: "#003e4c", fontSize: 14, fontFamily: "Rubik",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 6,
      lineHeight: 1,
      marginTop: '1%'
    },
  },
  // screen 4

  leftContainer4: {
    width: "40%",
    paddingLeft: "10%",
    paddingRight: "5%",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      paddingLeft: "5%",
      paddingRight: "2%",

    },
  },

  titleText4: {
    color: "#003e4c",
    fontSize: 22,
    textAlign: 'left',
    width: "100%",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 12,
      margin: 0,
    },
  },
  questionContainer4: {
    display: "flex",
    flexDirection: "column",
    width: "85%",
    alignItems: "start",
    paddingTop: "5%",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      paddingTop: "0%"
    },
  },
  question1Text4: {
    padding: 0,
    textAlign: "left",
    color: "#043e4b",
    fontSize: 24,
    fontWeight: 500,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 12,
    },
  },
  question2Text4: {
    padding: 0,
    paddingTop: "5%",
    textAlign: "left",
    color: "#043e4b",
    fontSize: 24,
    fontWeight: 500,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 12,
    },
   },

   socialCostIcon4:{
    height: 70, width: 70, position: "absolute", zIndex: 10, right: "-13%", top: "62%",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 25,
      width: 45,
      top: 170,
      // right: "-14%",
      left: 315,
    },
  },
  demandIcon4:{
    height: 80, width: 80, position: "absolute", zIndex: 10, right: "12%", top: "62%",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 25,
      width: 55,
      top: 170,
      left: 225,
      // right: "-14%",
    },
  },

  supplyIcon4: {
    height: 70, width: 70, position: "absolute", zIndex: 10, right: "-12%", top: 120,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 12,
      width: 45,
      top: 50,
      left: 315,
    },
  },

  //  specfic 5
  questionText5: {
    color: "#003e4c",
    fontSize: 32,
    textAlign: 'left',
    width: "100%",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 14,
      margin: 0
    },
  },

  optionContainer5: {
    display: 'flex',
    // border: '1px solid #ccc',
    padding: '10px',
    margin: '10px',
    cursor: 'pointer',
    fontSize: 23,
    fontFamily: 'Rubik',
    fontWeight: 500,
    width: "80%",
    transition: 'background-color 0.5s, color 0.5s',  // Smooth transition
    textAlign: "start",
    alignItems: "self-start",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 12,
      margin: 0
    },
  },

  // specfic 6
  questionText6: {
    color: "#003e4c",
    fontSize: 34,
    textAlign: 'left',
    width: "100%",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 16,
    },
  },
  labelsContainer6: {
    position: 'relative',
    // background: 'red',
    width: 600,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      width: 370,
    },
  },
  Ps6: {
    position: "absolute", zIndex: 10, color: "#003e4c", fontSize: 22, fontWeight: "bold",  left: -30, top: 150,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 12,
      left: -16,
      top: 64,
    },
  },
  Pm6: {
    position: "absolute", zIndex: 10, color: "#003e4c", fontSize: 22, fontWeight: "bold",  left: -30, top: 190,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 12,
      left: -16,
      top: 85,
    },
  },
  Qm6: {
    position: "absolute", zIndex: 10, color: "#003e4c", fontSize: 22, fontWeight: "bold",  left: "44%", top: 370,
    // position: "absolute", zIndex: 10, color: "#003e4c", fontSize: 22, fontWeight: "bold",  left: "28%", top: 370,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 12,
      left: "48%",
      top: 175,
    },
  },
  Qe6: {
    position: "absolute", zIndex: 10, color: "#003e4c", fontSize: 22, fontWeight: "bold",  left: "56%", top: 370,
    // position: "absolute", zIndex: 10, color: "#003e4c", fontSize: 22, fontWeight: "bold",  left: "41%", top: 370,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 12,
      left: "60%",
      top: 175,
    },
  },
  socialCostIcon6: {
    height: 70, width: 70, position: "absolute", zIndex: 10, right: 50, top: 330,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 25,
      width: 45,
      top: 160,
      left: 315,
    },
  },
  supplyIcon6:{
    height: 70, width: 70, position: "absolute", zIndex: 10, right: 50, top: 50,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 12,
      width: 45,
      top: 20,
      left: 315,
    },
  },
  demandIcon6: {
    height: 80, width: 80, position: "absolute", zIndex: 10, right: 170, top: 330,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 25,
      width: 55,
      top: 160,
      left: 225,
    },
  },
  buttonContainer6: {
    marginLeft: '-25%', marginTop: 120,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      marginLeft: '-35%', marginTop: 30,
    },
  },
  buttonSubmit6: {
    padding: "10px 20px", color: "#fff", fontSize: 24, fontWeight: 600, backgroundColor: "#00b1d9", border: "none", float: "left", cursor: "pointer", fontFamily: "Oswald", textTransform: "uppercase",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      padding: "5px 10px", fontSize: 12
    },
  },
  clearButton6: {
    padding: "10px 20px", color: "#00b1d9", marginLeft: 20, fontSize: 24, fontWeight: 600, backgroundColor: "#fff", border: "none", float: "left", cursor: "pointer", fontFamily: "Oswald", textTransform: "uppercase",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      padding: "5px 10px", fontSize: 12
    },
  },
  nextButton6: {
    padding: "10px 50px", color: "#fff", fontSize: 24, fontWeight: 600, backgroundColor: "#00b1d9", border: "none", float: "left", cursor: "pointer", fontFamily: "Oswald", textTransform: "uppercase" ,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      padding: "5px 20px",
      fontSize: 12,
      marginLeft: 50,
    },
  },
  // specfic 7
  questionText7: {
    textAlign: "left", color: "#043e4b", fontSize: 24, fontWeight: 500,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 12
    },
  },
  taxIcon: {
    height: 135, width: 88, position: "absolute", zIndex: 10, left: "39%", top: 244,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 70,
      width: 70,
      left: 135,
      top: 90,
    },
  }
});
export default BubbleLine1Styles;